import { IAllPrivateRoutes } from "components/routes/app_routes";

export const NotificationRoutes: IAllPrivateRoutes[] = [];